import React from 'react'

import styled from 'styled-components'
import { SvgSpinner } from '@chilipiper/icons/lib/Spinner'

import { SpaceProps } from '../theme/spacing'
import { SystemProps } from '../theme'

import { Flex } from '../box'
import { Icon } from '../icon'

type Props = SystemProps & {
  size: SpaceProps
}

const AnimatedIcon = styled(Icon)`
  animation: spinner 1s linear infinite;

  @keyframes spinner {
    100% {
      transform: rotate(1turn);
    }
  }
`

export const Loader = ({ size, ...props }: Props) => {
  return (
    <Flex alignItems='center' justifyContent='center' {...props}>
      <AnimatedIcon {...props} w={size} h={size} icon={SvgSpinner} />
    </Flex>
  )
}

Loader.defaultProps = {
  width: '100%',
  height: '100%',
  size: 6,
  color: 'orange-dark-100',
}
